import { UNID } from '../actionTypes'

// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],

  // Selected detail
  selectedUnidData: null,

  // Operation states
  saving: false,
  error: null,

  // List states for table
  items: [],
  loading: false,
  deleting: false
}

const unidReducer = (state = initialState, action) => {
  console.log('=== UNID REDUCER DEBUG ===')
  console.log('Action type:', action.type)
  console.log('Action payload:', action)
  console.log('Current state:', state)
  
  switch (action.type) {
    // List for selects/options
    case UNID.GET_DATA:
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }

    // Detail
    case UNID.GET_SELECTED_DETAIL:
      return { ...state, selectedUnidData: action.unidData }
    case UNID.RESET_SELECTED_DETAIL:
      return { ...state, selectedUnidData: null }

    // Create
    case UNID.CREATE_REQUEST:
      return { ...state, saving: true, error: null }
    case UNID.CREATE_SUCCESS:
      return { 
        ...state, 
        saving: false, 
        error: null, 
        data: [...state.data, action.unid],
        items: [...state.items, action.unid],
        total: state.total + 1
      }
    case UNID.CREATE_FAILURE:
      return { ...state, saving: false, error: action.error }

    // Update
    case UNID.UPDATE_REQUEST:
      return { ...state, saving: true, error: null }
    case UNID.UPDATE_SUCCESS:
      return {
        ...state,
        saving: false,
        error: null,
        data: state.data.map(unid => (unid.uuid === action.unid.uuid ? action.unid : unid)),
        items: state.items.map(unid => (unid.uuid === action.unid.uuid ? action.unid : unid))
      }
    case UNID.UPDATE_FAILURE:
      return { ...state, saving: false, error: action.error }

    // Fetch list for table
    case UNID.LIST_REQUEST:
      return { ...state, loading: true, error: null }
    case UNID.LIST_SUCCESS:
      return { ...state, loading: false, error: null, items: action.items, total: action.total }
    case UNID.LIST_FAILURE:
      return { ...state, loading: false, error: action.error }

    // Delete
    case UNID.DELETE_REQUEST:
      return { ...state, deleting: true, error: null }
    case UNID.DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        error: null,
        items: state.items.filter(item => (item.id || item.uuid) !== action.id),
        total: Math.max(0, state.total - 1)
      }
    case UNID.DELETE_FAILURE:
      return { ...state, deleting: false, error: action.error }

    default:
      return state
  }
}

export default unidReducer

